import type { Severity } from '@prerender/diagnostics-api';

export const SEVERITY_LABELS: Record<Severity, string> = {
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  critical: 'Critical',
};

export function severityLabel(severity: Severity): string {
  return SEVERITY_LABELS[severity] ?? String(severity);
}
